import React from 'react'
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import HalfSizeBanner from '../../../components/Banners/HalfSizeBanner';
import SmallCards from '../../../components/Cards/SmallCards';
import Accordions from '../../../components/Accordions/Accordions';
import { Link } from 'react-router-dom';
import { useTranslation } from '../../../hook/Translation';

export default function AlmaPostMenopauseConditions() {
    const { t } = useTranslation();
    const data = [
        {
            imageUrl: '/images/fractional/hourglass-end.svg',
            title: t('time'),
            description: '45 to 90 min'
        },
        {
            imageUrl: '/images/fractional/headache.svg',
            title: t('discomfort'),
            description: '45 to 90 min'
        },
        {
            imageUrl: '/images/fractional/duration.svg',
            title: t('downtime'),
            description: '45 to 90 min'
        },
        {
            imageUrl: '/images/fractional/facial-treatment.svg',
            title: t('sessions'),
            description: '45 to 90 min'
        }
    ];

    const ENZYME_THERAPY = [
        {
            title: 'What is it',
            content: 'A laser treatment designed for post-menopausal vaginal and urogenital symptoms.'
        },
        {
            title: 'How it works',
            content: 'Fractional energy remodels collagen, revitalizes tissue, and restores moisture and tone.'
        },
        {
            title: 'Benefits',
            content: 'Reduced dryness, better elasticity, improved comfort, enhanced intimate wellness.'
        },
        {
            title: 'Areas',
            content: 'Internal vaginal canal, external vulvar area when necessary.'
        },
        {
            title: 'Pairs with other treatments',
            content: 'FemiTight series, urinary incontinence laser therapy, or external labial rejuvenation.'
        },
        {
            title: 'When to expect results',
            content: 'Gradual improvement over several weeks; optimal comfort reached by 6–8 weeks post-treatment cycle.'
        },
    ];
    return (
        <Box>
            <HalfSizeBanner>
                <Grid container sx={{ backgroundColor: 'text.secondary', height: 1, width: 1 }} justifyContent={'center'} alignItems={'center'} position={'relative'} paddingY={{md: 'none', xs: '20px'}} paddingX={{md: 'none', xs: '20px'}}>
                    <Grid size={{ lg: 6, xs: 12 }} >
                        <Grid container gap={'20px'} justifyContent={'center'} alignItems={'center'} height={'max-content'}>
                            <Grid size={{md: 7, xs: 12}}>
                                <Typography variant="h1" color='text.primary' fontWeight={'bold'} fontFamily={'DanmarkURW'} fontSize={{ md: '46px', xs: '30px' }}>Post-Menopause Conditions</Typography>
                            </Grid>
                            <Grid size={{md: 7, xs: 12}}>
                                <Typography variant="body1" color='text.primary'>A non-hormonal, laser-based solution addressing symptoms such as vaginal dryness, laxity, discomfort, and mild urinary incontinence. Ideal for women seeking a safe, energy-based alternative to hormone therapy.</Typography>
                                <Box marginTop={'14px'}>
                                    <Button variant='outlined' className='borderRadiusFlat borderWidth2 buttonPaddingY10' color='text.secondary' sx={{ backgroundColor: '#FFF', borderColor: '#FFF', fontSize: '18px', maxHeight: '50px', width: { md: '246px', xs: '100%' } }}>Book Now</Button>
                                </Box>
                            </Grid>
                        </Grid>
                    </Grid>
                    <Grid size={{ lg: 6, xs: 12 }} height={1} position={{md: 'relative', xs: 'absolute'}} top={{md: 'unset', xs: 0}} left={{md: 'unset', xs: 0}} sx={{ opacity: {md: 1, xs: 0.7} }}>
                        <Box width={1} height={1}>
                            <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/27/Mask Group 4.png`} alt='Mask Group 4.png' width={'100%'} height={'100%'} sx={{ objectFit: 'cover' }} />
                        </Box>
                    </Grid>
                </Grid>
            </HalfSizeBanner>

            <Box className="generalContainer" marginX={'auto'} marginTop={{ md: '90px', xs: '50px' }}>
                <Grid container spacing={8} position={'relative'} height={{ md: 400, xs: 'auto' }} padding={{ md: 'unset', xs: '20px' }}>
                    <Grid size={{ md: 6, xs: 12 }} position={{ md: 'relative', xs: 'absolute' }} top={0} left={0} width={1} height={1} zIndex={{ md: 'unset', xs: 1 }} sx={{ opacity: { md: 1, xs: 0.7 } }}>
                        <Box component={'img'} src={`${process.env.REACT_APP_SITE_URL}/images/2025/27/Mask Group 8.png`} alt='Mask Group 8.png' loading='lazy' className='fitCover' width={1} height={1} />
                    </Grid>
                    <Grid size={{ md: 6, xs: 12 }} zIndex={2} justifyContent={'center'} alignItems={'center'} flexDirection={'column'} display={'flex'}>
                        <Grid size={12}>
                            <Grid container spacing={{ md: 4, xs: 3 }}>
                                <Grid size={12}>
                                    <Typography textAlign={'center'} gutterBottom variant="h3" color="text.secondary" fontFamily={'DanmarkURW'} fontSize={{ md: '2.875rem', xs: '2rem' }} fontWeight={'bold'}>Technology</Typography>
                                    <Typography textAlign={'center'} marginTop={'30px'} variant="body1" color="text.secondary" fontSize={{ md: '1rem', xs: '0.875rem' }}>A non-hormonal, laser-based solution addressing symptoms such as vaginal dryness, laxity, discomfort, and mild urinary incontinence. Ideal for women seeking a safe, energy-based alternative to hormone therapy.</Typography>
                                </Grid>
                            </Grid>
                        </Grid>
                        {/* <Grid size={12} marginTop={'30px'}>
                            <Grid container height={1} spacing={4} alignItems={'center'} justifyContent={'center'}>
                                <Grid size={'auto'}>
                                    <Button LinkComponent={Link} to={""} fullWidth variant='contained' className='borderRadiusFlat borderWidth2 buttonPaddingY10 placeBorder defaultBorderColor noShadow defaultButton buttonTextSize' sx={{ color: 'primary.main', backgroundColor: 'secondary.main' }}>
                                        BOOK NOW
                                    </Button>
                                </Grid>
                            </Grid>
                        </Grid> */}
                    </Grid>
                </Grid>
            </Box>

            <Box>
                <Box marginTop={{ md: '205px', xs: '50px' }} className='generalContainer' marginX={'auto'}>
                    <SmallCards data={data} />
                </Box>
            </Box>

            <Grid container gap={{ md: '80px', xs: '25px' }} className='generalContainer' mx={'auto'} sx={{ marginTop: { md: '120px', xs: '50px' } }} paddingBottom={{ md: '110px', xs: '50px' }}>
                <Grid size={12}>
                    <Typography textAlign={'center'} variant="body1" color="text.secondary" fontSize={'1.125rem'} fontWeight={'600'}>Additional Information</Typography>
                </Grid>
                <Grid size={12}>
                    <Accordions data={ENZYME_THERAPY} />
                </Grid>
            </Grid>

        </Box>
    )
}
